import { useQuery } from "@tanstack/react-query"
import { useCallback } from "react"
import { Product, ProductData } from "../../../types"
import { fetchGeojson } from "../../../utils/fetchUtils"
import { prepareProductData } from "./utils/prepareProductData"
import { useGetImdf } from "../useGetImdf"

export const useGetProducts = () => {
  const { data: imdfData } = useGetImdf()
  const findOne = useCallback(
    (id) => imdfData.features.find((f) => f.id === id),
    [imdfData]
  )
  return useQuery<Product[], unknown, ProductData[]>({
    queryKey: ["products"],
    queryFn: async () => {
      const response = await fetchGeojson<Product>("product", "/")
      return response.data
    },
    select: (products: Product[]): ProductData[] =>
      products.map((product) => prepareProductData(product, findOne)),
    placeholderData: [],
    refetchOnWindowFocus: false,
    enabled: !!imdfData,
  })
}
